import { storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc';
import { colorStyle } from '@/lib/helpers';
import CarouselClient from '@/components/CarouselClient';

/**
 * Carousel — horizontal slider of arbitrary blocks. Slides render on the server;
 * CarouselClient adds the arrows / numbered-or-dot indicators / swipe. How many
 * slides show at once (desktop / mobile) and which controls appear are editable.
 */
const Carousel = ({ blok }) => {
  const slides = blok.slides || [];
  // Optional column beside the track (heading / intro). Rendered here because
  // these are server components; CarouselClient just places them.
  const side = blok.side_content || [];

  return (
    <div {...storyblokEditable(blok)} style={colorStyle(blok)}>
      <CarouselClient
        slidesDesktop={Number(blok.slides_desktop) || 3}
        slidesMobile={Number(blok.slides_mobile) || 1}
        showArrows={blok.show_arrows !== false}
        arrowDisplay={blok.arrow_display || 'mobile'}
        indicators={blok.indicators || 'numbers'}
        initialActive={(Number(blok.initial_slide) || 1) - 1}
        loop={blok.loop === true}
        stackMobile={blok.stack_mobile === true}
        group={blok.group || ''}
        sideContent={side.length ? side.map((b) => <StoryblokServerComponent blok={b} key={b._uid} />) : null}
      >
        {slides.map((slide) => (
          // Stretch each slide's block to full height so all cards are equal.
          // Alignment comes from the track (see carousel.css); only the height is set here.
          <div key={slide._uid} className="[&>*]:h-full">
            <StoryblokServerComponent blok={slide} />
          </div>
        ))}
      </CarouselClient>
    </div>
  );
};

export default Carousel;
